<template>
  <div>
    <div class="card mb-5 mb-3">
      <div class="card-header">
        <h3 class="card-title flex-row"><i class="fa fa-list"></i> <span class="card-label fs-3 ms-1">Quản lý
            câu hỏi thường gặp</span></h3>
      </div>
      <div class="card-body">
        <el-row :gutter="10">
          <el-col :xs="24" :sm="24" :md="12" :lg="6" :xl="6">
            <label>Câu hỏi:</label>
            <el-row :gutter="10">
              <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                <el-input clearable placeholder="Câu hỏi..." v-model="search.cCauHoi" />
              </el-col>
            </el-row>
          </el-col>
          <!-- <el-col :xs="24" :sm="24" :md="12" :lg="6" :xl="6">
            <label>Mô tả:</label>
            <el-row :gutter="10">
              <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                <el-input clearable placeholder="Mô tả..." v-model="search.cMoTa" />
              </el-col>
            </el-row>
          </el-col> -->
          <el-col :xs="24" :sm="24" :md="12" :lg="6" :xl="6">
            <label>Trạng thái:</label>
            <el-row :gutter="10">
              <el-col :xs="20" :sm="22" :md="20" :lg="20" :xl="22">
                <el-select placeholder="Tất cả" v-model="search.nTrangThai">
                  <el-option label="Tất cả" value="" selected></el-option>
                  <el-option label="Hoạt động" value="1" selected></el-option>
                  <el-option label="Đã xóa" value="0" selected></el-option>
                </el-select>
              </el-col>
              <el-col :xs="4" :sm="2" :md="4" :lg="4" :xl="2">
                <el-button plain type="primary" title="Tìm kiếm" @click="handleFindPage"><i
                    class="fa fa-search"></i></el-button>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
      </div>
    </div>

    <div class="card data-table mb-5 mb-xl-10">
      <div class="card-header py-3">
        <div class="body-function">
          <div class="col-md-6">
            <el-button plain type="primary" outline native-type="submit" @click="handleOpenAdd" data-bs-toggle="modal"
              data-bs-target="#modal_news" :disabled="!handleCheckPerms('p:questions:add')">
              <span class="btn-inner--icon"><i class="fas fa-plus"></i></span>
              <span class="btn-inner--text">&nbsp;Thêm câu hỏi</span>
            </el-button>
          </div>
          <!-- <div class="col-md-6" style="text-align:right">
              <el-button plain icon="el-icon-refresh" size="small" style="margin-right:30px" title="Đồng bộ" type="warning" @click=""
                v-loading.fullscreen.lock="isLoading"></el-button>
            </div> -->
        </div>
      </div>
      <div class="card-body">
        <div class="col-md-12 tbl">
          <el-table :data="tableData.content" header-row-class-name="thead-light" style="height: 100%" height="100%" fit
            stripe highlight-current-row>
            <el-table-column prop="nMaCauHoi" label="Mã" align="center" width="80"></el-table-column>
            <el-table-column prop="cCauHoi" show-overflow-tooltip class="text-nowrap" label="Câu hỏi">
            </el-table-column>
            <!-- <el-table-column prop="cCauTraLoi" class="text-nowrap" label="Nội dung" header-align="center">
              <template #default="scope">
                <span class="text-nowrap" style="max-height: ;" v-html="scope.row.cCauTraLoi"></span>
              </template>
</el-table-column> -->
            <el-table-column prop="dNgayTao" label="Ngày tạo" align="center" width="120">
              <template #default="scope">
                {{ momentDate(scope.row.dNgayTao) }}
              </template>
            </el-table-column>
            <el-table-column prop="nTrangThai" label="Trạng thái" width="120" align="center">
              <template #default="scope">
                <el-tag type="success" v-if="scope.row.nTrangThai == 1" size="small">Hoạt Động</el-tag>
                <el-tag type="danger" v-if="scope.row.nTrangThai == 0" size="small">Đã xóa</el-tag>
              </template>
            </el-table-column>
            <el-table-column label="Hành động" align="center" width="150">
              <template #default="scope">
                <el-button plain type="primary" :disabled="scope.row.nTrangThai == 0 || !handleCheckPerms('p:questions:edit')" data-bs-toggle="modal"
                  data-bs-target="#modal_news" @click="handleOpenEdit(scope.row)">
                  <span class="btn-inner--icon"><i class="fas fa-edit"></i></span>
                </el-button>

                <el-button plain type="danger" :disabled="scope.row.nTrangThai == 0 || !handleCheckPerms('p:questions:delete')"
                  v-loading.fullscreen.lock="isLoading" @click="handleDelete(scope.row)">
                  <span class="btn-inner--icon"><i class="fas fa-trash"></i></span>
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div class="col-12 py-2 pagination" style="justify-content: end">
        <el-pagination @size-change="handleChangePageSize" @current-change="handleChangePageNum"
          :current-page.sync="tableData.pageNum" :page-sizes="[5, 10, 20, 30, 40]" :page-size="tableData.pageSize"
          layout="total, sizes, prev, pager, next, jumper" :total="tableData.totalSize">
        </el-pagination>
      </div>
    </div>

    <div class="modal fade" id="modal_news" ref="newsModalRef" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered mw-1000px">
        <div class="modal-content">
          <!--begin::Modal header-->
          <div class="modal-header" id="modal_news_header">
            <!--begin::Modal title-->
            <h2 class="fw-bolder">{{ !operation ? "Thêm câu hỏi" : "Cập nhật câu hỏi" }}</h2>
            <div class="btn btn-sm btn-icon btn-active-color-primary" data-bs-dismiss="modal" @click="handleClose">
              <span class="svg-icon svg-icon-1">
                <inline-svg src="/media/icons/duotune/arrows/arr061.svg" />
              </span>
            </div>
            <!--end::Close-->
          </div>
          <!--end::Modal header-->
          <div class="modal-body mh-600px overflow-scroll">
            <el-form :model="formData" :rules="rules" ref="formDataRef" label-width="120px" class=" d-flex flex-column">
              <el-form-item label="Câu hỏi" prop="cCauHoi">
                <el-input v-model="formData.cCauHoi" />
              </el-form-item>
              <el-form-item label="Câu trả lời" prop="cCauTraLoi">
                <div class="w-100">
                  <QuillEditor class="w-100 d-flex flex-column" ref="quillEditor" @text-change="onTextChange"
                    :options="quillOptions" />
                </div>
              </el-form-item>
            </el-form>
          </div>
          <div class="modal-footer">
            <div class="btn-group">
              <el-button plain v-if="!operation" type="primary" v-loading.fullscreen.lock="isLoading"
                @click="handleSave">Thêm</el-button>
              <el-button plain v-if="operation" type="primary" v-loading.fullscreen.lock="isLoading"
                @click="handleSave">Lưu</el-button>
              <el-button plain type="danger" @click="handleClose">Thoát</el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog v-model="dialogVisible" class="bg-transparent w-auto shadow-none">
      <img class="mh-500px mw-1000px" :src="dialogImageUrl" alt="Preview Image" />
    </el-dialog>
  </div>
</template>
<script>
import { Questions } from "@/store/enums/StoreEnums";
import moment from "moment";
import { useStore } from "vuex";
import { hideModal } from "@/core/helpers/dom";
import ImageResize from "quill-image-resize";
import { baseUrl } from "@/utils/global";
import { QuillEditor, Quill } from '@vueup/vue-quill'
import '@vueup/vue-quill/dist/vue-quill.snow.css';
import { ElMessage } from "element-plus";
import { CookieComponent } from "@/assets/ts/components";

Quill.register("modules/imageResize", ImageResize);

export default {
  name: 'Questions',
  components: {
    QuillEditor
  },
  data() {
    return {
      
      perms: CookieComponent.get("permissions") ? JSON.parse(CookieComponent.get("permissions")) : [], 
      test: "",
      customToolbar: [
        [{ header: [false, 1, 2, 3, 4, 5, 6] }],
        ["bold", "italic", "underline"],
        [{ list: "ordered" }, { list: "bullet" }],
        [{ 'color': [] }, { 'background': [] }],
        [{ align: "" }, { align: "center" }, { align: "right" }, { align: "justify" }],
        [{ indent: "-1" }, { indent: "+1" }],
        [/* "image", */ "link"], ["clean"]
      ],
      editorSettings: {
        modules: {
          imageResize: {}
        }
      },
      quillOptions: {
        theme: 'snow',
        modules: {
          imageResize: {},
          toolbar: {
            container: [
              [{ header: [false, 1, 2, 3, 4, 5, 6] }],
              ["bold", "italic", "underline"],
              [{ list: "ordered" }, { list: "bullet" }],
              [{ 'color': [] }, { 'background': [] }],
              [{ align: "" }, { align: "center" }, { align: "right" }, { align: "justify" }],
              [{ indent: "-1" }, { indent: "+1" }],
              [/* "image", */ "link"], ["clean"],
            ]/* ,
            handlers: {
              image: this.customImageHandler
            } */
          }
        }
      },
      search: {
        cCauHoi: "",
        nTrangThai: null,
      },
      pageRequest: {
        columnFilters: {},
        pageSize: 30,
        pageNum: 1
      },
      formData: {
        cCauHoi: "",
        cCauTraLoi: "",
        /* imageFile: [] */
      },
      rules: {
        cCauHoi: [{ required: true, message: "Xin vui lòng điền tiêu đề", trigger: "blur" }],
        /*  cMoTa: [{ required: true, message: "Xin vui lòng điền mô tả", trigger: "blur" }], */
        cCauTraLoi: [{ required: true, message: "Xin vui lòng điền nội dung", trigger: "blur" }],
        /* imageFile: [
          {
            required: true, message: 'Xin vui lòng chọn bản ghi', trigger: 'change', validator: (rule, value, callback) => {
              if (this.imageFile.length === 0) {
                callback(new Error('Xin vui lòng chọn bản ghi'));
              } else {
                callback();
              }
            }
          },
        ], */
      },
      tableData: {
        content: [{}]
      },
      isLoading: false,
      modalVisible: false,
      operation: false,
      iframeURL: "",
      openIframe: false,
      isSearchLoading: false,
      store: useStore(),
      /* imageFile: [], */
      dialogImageUrl: null,
      dialogVisible: false,
    }
  },
  methods: {
    handleChangePageNum(val) {
      this.pageRequest.pageNum = val
      this.handleFindPage()
    },
    handleChangePageSize(val) {
      this.pageRequest.pageSize = val
      this.handleFindPage()
    },
    /* customImageHandler() {
      const input = document.createElement('input')
      input.setAttribute('type', 'file')
      input.setAttribute('accept', 'image/*')
      input.click()

      input.onchange = () => {
        const file = input.files[0]
        const reader = new FileReader()

        reader.onload = (e) => {
          const quill = this.$refs.quillEditor.getQuill()
          const range = quill.getSelection()
          const formData = new FormData()
          formData.append("image", file);
          this.store.dispatch(Questions.uploadArticleImage, formData).then(res => {
            if (res.code == 200) {
              const url = baseUrl + res.msg
              quill.insertEmbed(range.index, "image", url);
            } else {
              ElMessage({ message: "Thêm hình ảnh không thành công", type: "error" })
            }
          }).catch(() => {
            ElMessage({ message: "Thêm hình ảnh không thành công", type: "error" })
          })
        }

        reader.readAsDataURL(file)
      }
    }, */
    handleOpenAdd() {
      this.$refs.formDataRef.resetFields()
      this.modalVisible = true
      this.operation = false
      this.formData = {}
      /* this.imageFile = [] */
      this.$refs.quillEditor.setHTML("")
    },
    handleOpenEdit(val) {
      this.$refs.formDataRef.resetFields()
      this.modalVisible = true
      this.operation = true
      this.formData = Object.assign({}, val)
      /* this.imageFile = [] */
      this.$refs.quillEditor.setHTML(val.cCauTraLoi)
      /* if (val.cBannerUrl) {
        this.addImageFromURL(baseUrl + val.cBannerUrl)
      } */
    },
    handleClose() {
      this.$refs.formDataRef.resetFields()
      this.modalVisible = false
      hideModal(this.$refs.newsModalRef)
    },
    handleDelete(val) {
      
      this.$confirm("Bạn có muốn xóa câu hỏi này không?", "Xác nhận", {
        confirmButtonText: "Xác nhận",
        cancelButtonText: "Hủy",
        type: "warning",
      })
        .then(() => {
          this.store.dispatch(Questions.deleteQuestions, val.nMaCauHoi).then(res => {
            if (res.code == 200) {
              ElMessage({ message: "Xóa câu hỏi thành công", type: "success" });
              this.handleFindPage()
            } else {
              ElMessage({ message: res.msg, type: "error" });
            }
          }).catch((error) => {
            ElMessage({ message: "Xóa câu hỏi thất bại", type: "error" });
          })
        }).catch(() => {

        })
    },
    handleFindPage() {
      this.pageRequest.columnFilters = {
        cCauHoi: { value: this.search.cCauHoi },
        nTrangThai: { value: this.search.nTrangThai },
      }
      this.store.dispatch(Questions.findPageQuestions, this.pageRequest).then(res => {
        if (res.code == 200) {
          this.tableData = res.data
        }
      }).catch((error) => {
        ElMessage({ message: "Tìm câu hỏi thất bại", type: "error" });
      })
    },
    /* async handleChangeFile(file, imageFile) {
      this.imageFile = [file]
      this.formData.imageFile = this.imageFile
    },
    handleRemoveFile(file, imageFile) {
      this.formData.imageFile = []
      this.formData.imageFile = this.imageFile
    }, */

    onTextChange(val) {
      /*  if (JSON.stringify(val.delta.ops).includes("delete")) {
         let deletedImages = val.oldContents.ops.filter(val1 => val1.insert.image && !this.$refs.quillEditor.getHTML().includes(val1.insert.image))
         for (let i = 0; i < deletedImages.length; i++) {
           this.store.dispatch(Questions.removeArticleImage, deletedImages[i].insert.image.replace(baseUrl + "/image/news/", ""))
         }
       } */
      this.formData.cCauTraLoi = this.$refs.quillEditor.getHTML()
    },
    handleSave() {
      this.$refs.formDataRef.validate((valid) => {
        if (valid)
          this.$confirm("Bạn có muốn lưu câu hỏi này không?", "Xác nhận", {
            confirmButtonText: "Xác nhận",
            cancelButtonText: "Hủy",
            type: "warning",
          }).then(() => {

            const formData = new FormData()
            /* if (this.imageFile.length > 0) {
              if (this.imageFile[0].status == "ready") {
                formData.append('image', this.imageFile[0].raw)
              }
            } */
            formData.append("record", new Blob([JSON.stringify(this.formData)], { type: "application/json" }))
            //console.log(this.formData)
            if (this.operation) {
              this.store.dispatch(Questions.saveQuestions, this.formData).then(res => {
                if (res.code == 200) {
                  this.handleFindPage()
                  this.handleClose()
                  ElMessage({ message: "Cập nhật câu hỏi thành công", type: "success" })
                } else {
                  ElMessage({ message: "Cập nhật câu hỏi không thành công", type: "error" })
                }
              }).catch(() => {
                ElMessage({ message: "Cập nhật câu hỏi không thành công", type: "error" })
              })
            } else {
              this.store.dispatch(Questions.saveQuestions, formData).then(res => {
                if (res.code == 200) {
                  this.handleFindPage()
                  this.handleClose()
                  ElMessage({ message: "Thêm câu hỏi mới  thành công", type: "success" })
                } else {
                  ElMessage({ message: "Thêm câu hỏi mới không thành công", type: "error" })
                }
              }).catch(() => {
                ElMessage({ message: "Thêm câu hỏi mới không thành công", type: "error" })
              })
            }
          }).catch(() => {

          })
      })
    },
    momentDate(val) {
      return val ? moment(val).format("DD/MM/YYYY") : ""
    },
    /* addImageFromURL(url) {
      fetch(url)
        .then(res => res.blob())
        .then(blob => {
          const file = new File([blob], "image.jpg", { type: blob.type });
          this.imageFile.push({
            name: file.name,
            url: URL.createObjectURL(file),
            status: 'success',
            uid: Date.now(),
            raw: file
          });
        });
    }, */
    handlePictureCardPreview(val) {
      this.dialogImageUrl = val.url
      this.dialogVisible = true
    },
    handleCheckPerms(val){
      return this.perms.includes(val)
    }
  },
  mounted() {
    this.handleFindPage()
  }
};
</script>
<style lang="scss"></style>